if (!customElements.get('mr-gift-checkout')) {
  customElements.define('mr-gift-checkout', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.form = this.closest('form');
      this.button = this.querySelector('[name="checkout"]');
      this.form?.addEventListener('submit', event => this.check(event), { capture: true, signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller.abort();
    }

    async check(event) {
      if (this.validated || (event.submitter && event.submitter.name !== 'checkout')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.pending) return;
      this.pending = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      const error = this.querySelector('[data-gift-error]');
      const networkError = this.querySelector('[data-gift-network-error]');
      error.hidden = true;
      networkError.hidden = true;
      let blocked = false;
      try {
        const response = await fetch(this.dataset.cartUrl, { cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
        const isGift = item => String(item.product_id) === this.dataset.giftProductId || String(item.product_id) === '15397513724093' || item.handle === 'giftset';
        blocked = cart.items.some(isGift) && !cart.items.some(item => !isGift(item));
        if (!this.isConnected) return;
        if (blocked) {
          error.hidden = false;
          error.focus();
          return;
        }
        // Recheck delivery rules after the cart request, including scheduled boundaries.
        await window.MRDelivery?.refresh();
        if (!this.isConnected) return;
        this.button.disabled = false;
        this.validated = true;
        try {
          this.form.requestSubmit(this.button);
        } finally {
          this.validated = false;
        }
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          networkError.hidden = false;
          networkError.focus();
        }
      } finally {
        this.pending = false;
        this.button.disabled = blocked;
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}
